import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import { articles } from "@/data/articles";

function ArticleCard({ article, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{
        duration: 0.85,
        delay: (index % 2) * 0.06,
        ease: [0.22, 1, 0.36, 1],
      }}
    >
      <Link
        to={`/writing/${article.id}`}
        className="group block card-shrine rounded-sm overflow-hidden bg-shrine-shadow transition-transform duration-700 ease-breath hover:-translate-y-0.5"
      >
        <div className="aspect-[3/2] overflow-hidden">
          <img
            src={article.hero_url}
            alt={article.title}
            className="w-full h-full object-cover transition-transform duration-1000 ease-breath group-hover:scale-[1.02]"
            loading={index < 2 ? "eager" : "lazy"}
          />
        </div>
        <div className="p-6 md:p-8">
          <p className="font-body text-[0.7rem] text-cream/60 tracking-widest2 uppercase mb-2">
            {article.subtitle}
          </p>
          <h2 className="font-display text-cream text-2xl md:text-3xl tracking-tightish leading-tight">
            {article.title}
          </h2>
          {article.pull_quote && (
            <p className="font-serif italic text-cream/70 text-base md:text-lg mt-4 leading-relaxed">
              {article.pull_quote}
            </p>
          )}
          <p className="font-body text-[0.7rem] text-cream/45 tracking-widest2 uppercase mt-5">
            Read →
          </p>
        </div>
      </Link>
    </motion.div>
  );
}

export default function Writing() {
  return (
    <PageShell title="Writing">
      <PageHeader
        eyebrow="Writing"
        title="Long-form essays on the world's sacred texts."
        lede="One scripture at a time. Quietly considered. Painted slowly into something a thinking reader can sit with."
      />
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-5 md:px-10 lg:px-14">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-12">
            {articles.map((a, i) => (
              <ArticleCard key={a.id} article={a} index={i} />
            ))}
          </div>
        </div>
      </section>
    </PageShell>
  );
}
